function showTemp(response) {
  let temp = document.querySelector("#temp");
  let ws = document.querySelector("#ws");
  let h = document.querySelector("#h");
  let icon = document.querySelector("#icon");
  let d = document.querySelector("#d");

  // Check if the temperature data exists before setting it
  if (response.data.temperature.current) {
    temp.innerHTML = response.data.temperature.current;
    ws.innerHTML = response.data.wind.speed;
    h.innerHTML = response.data.temperature.humidity;
    icon.src = response.data.condition.icon_url;
    d.innerHTML = response.data.condition.description;
    let lat = response.data.coordinates.latitude;
    let lon = response.data.coordinates.longitude;
    let key = "a977ca1db7325d06a7ot283b4bbbfca0";
    let api = `https://api.shecodes.io/weather/v1/forecast?lat=${lat}&lon=${lon}&key=${key}&units=metric`;
    console.log(api);
    axios.get(api).then((response) => {
      let mon = document.querySelector("#monIMG");
      let tue = document.querySelector("#tueIMG");
      let wen = document.querySelector("#wenIMG");
      let thu = document.querySelector("#thuIMG");
      let fri = document.querySelector("#friIMG");
      let sat = document.querySelector("#satIMG");
      let sun = document.querySelector("#sunIMG");
      let Mmax = document.querySelector("#Mmax");
      let Mmin = document.querySelector("#Mmin");
      let Tumax = document.querySelector("#Tumax");
      let Tumin = document.querySelector("#Tumin");
      let wenmax = document.querySelector("#wenmax");
      let wenmin = document.querySelector("#wenmin");
      let thumax = document.querySelector("#thumax");
      let thumin = document.querySelector("#thumin");
      let frimax = document.querySelector("#frimax");
      let frimin = document.querySelector("#frimin");
      let satmax = document.querySelector("#satmax");
      let satmin = document.querySelector("#satmin");
      let sunmax = document.querySelector("#sunmax");
      let sunmin = document.querySelector("#sunmin");

      mon.src = response.data.daily[0].condition.icon_url;
      tue.src = response.data.daily[1].condition.icon_url;
      wen.src = response.data.daily[2].condition.icon_url;
      thu.src = response.data.daily[3].condition.icon_url;
      fri.src = response.data.daily[4].condition.icon_url;
      sat.src = response.data.daily[5].condition.icon_url;
      sun.src = response.data.daily[6].condition.icon_url;
      Mmax.innerHTML = parseInt(response.data.daily[0].temperature.maximum);
      Mmin.innerHTML = parseInt(response.data.daily[0].temperature.minimum);
      Tumax.innerHTML = parseInt(response.data.daily[1].temperature.maximum);
      Tumin.innerHTML = parseInt(response.data.daily[1].temperature.minimum);
      wenmax.innerHTML = parseInt(response.data.daily[2].temperature.maximum);
      wenmin.innerHTML = parseInt(response.data.daily[2].temperature.minimum);
      thumax.innerHTML = parseInt(response.data.daily[3].temperature.maximum);
      thumin.innerHTML = parseInt(response.data.daily[3].temperature.minimum);
      frimax.innerHTML = parseInt(response.data.daily[4].temperature.maximum);
      frimin.innerHTML = parseInt(response.data.daily[4].temperature.minimum);
      satmax.innerHTML = parseInt(response.data.daily[5].temperature.maximum);
      satmin.innerHTML = parseInt(response.data.daily[5].temperature.minimum);
      sunmax.innerHTML = parseInt(response.data.daily[6].temperature.maximum);
      sunmin.innerHTML = parseInt(response.data.daily[6].temperature.minimum);
    });
  } else {
    temp.innerHTML = "Temperature data not available";
  }38.71667
}

function search(event) {
  event.preventDefault();

  let searchInputElement = document.querySelector("#search-input");
  let apiKey = "a977ca1db7325d06a7ot283b4bbbfca0";
  let apiEndPoint = `https://api.shecodes.io/weather/v1/current?query=${searchInputElement.value}&key=${apiKey}`;
  let cityElement = document.querySelector("#current-city");
  cityElement.innerHTML = searchInputElement.value;

  // Use Axios to get the weather data
  axios.get(apiEndPoint).then((response) => showTemp(response));
}

function formatDate(date) {
  let minutes = date.getMinutes();
  let hours = date.getHours();
  let day = date.getDay();

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (hours < 10) {
    hours = `0${hours}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let formattedDay = days[day];
  return `${formattedDay} ${hours}:${minutes}`;
}

let searchForm = document.querySelector("#search-form");
searchForm.addEventListener("submit", search);

let currentDateELement = document.querySelector("#current-date");
let currentDate = new Date();

currentDateELement.innerHTML = formatDate(currentDate);